module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/14mill-active-83fb9b13858da471a828dc2b49101c53.png";